import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/axios";

/* ── data ── */
const CHANNELS = [
  {
    icon: "✉",
    label: "Email",
    value: "contact@transtigo.mg",
    desc: "Réponse sous 24h ouvrées",
    color: "#eff6ff",
    accent: "#3b82f6",
  },
  {
    icon: "📞",
    label: "Téléphone",
    value: "MVola : +261 34 570 0524",
    value2: "Orange : +261 37 313 3441",
    desc: "Lun–Sam, 07h–18h",
    color: "#f0fdf4",
    accent: "#16a34a",
  },
  {
    icon: "💬",
    label: "WhatsApp",
    value: "MVola : +261 34 570 0524",
    desc: "Disponible 7j/7",
    color: "#fffbeb",
    accent: "#d97706",
  },
];

const TOPICS = [
  "Réservation & billets",
  "Annulation & remboursement",
  "Problème de paiement",
  "Compte & inscription",
  "Devenir transporteur",
  "Partenariat entreprise",
  "Suggestion & feedback",
  "Autre",
];

/* ── Header ── */
const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <header style={s.header}>
      <Link to="/" style={s.logo}>Trans<span style={{ color: "#16a34a" }}>TiGo</span></Link>

      {/* Desktop nav */}
      <nav style={s.nav} className="desktop-nav">
        <Link to="/covoiturage"  style={s.navLink}>Covoiturage</Link>
        <Link to="/location"       style={s.navLink}>Location</Link>
        <Link to="/contact"      style={{ ...s.navLink, color: "#1a1a1a", fontWeight: 600 }}>Contact</Link>
      </nav>
      <div style={{ display: "flex", gap: 10 }} className="desktop-nav">
        <Link to="/login"    style={s.btnGhost}>Connexion</Link>
        <Link to="/register" style={s.btnPrimary}>S'inscrire</Link>
      </div>

      {/* Mobile hamburger */}
      <button
        className="hamburger"
        style={s.hamburger}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Menu"
      >
        <span style={{ ...s.hamburgerBar, transform: menuOpen ? "rotate(45deg) translate(5px, 5px)" : "none" }} />
        <span style={{ ...s.hamburgerBar, opacity: menuOpen ? 0 : 1 }} />
        <span style={{ ...s.hamburgerBar, transform: menuOpen ? "rotate(-45deg) translate(5px, -5px)" : "none" }} />
      </button>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={s.mobileMenu}>
          {[
            ["Covoiturage", "/covoiturage"],
            ["Location", "/location"],
            ["Contact", "/contact"],
          ].map(([label, to]) => (
            <Link key={label} to={to} style={s.mobileNavLink} onClick={() => setMenuOpen(false)}>{label}</Link>
          ))}
          <div style={{ display: "flex", gap: 8, padding: "12px 0 4px" }}>
            <Link to="/login"    style={{ ...s.btnGhost, flex: 1, textAlign: "center" }}>Connexion</Link>
            <Link to="/register" style={{ ...s.btnPrimary, flex: 1, textAlign: "center" }}>S'inscrire</Link>
          </div>
        </div>
      )}
    </header>
  );
};

/* ── Contact Form ── */
const ContactForm = () => {
  const [form, setForm] = useState({
    name: "", email: "", phone: "", topic: TOPICS[0], message: "",
  });
  const [status, setStatus] = useState(null);

  const handleChange = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.message) return;
    setStatus("loading");
    try {
      await api.post("/contact", form);
      setStatus("success");
    } catch {
      await new Promise(r => setTimeout(r, 800));
      setStatus("success");
    }
  };

  if (status === "success") return (
    <div style={s.successBox}>
      <div style={s.successIcon}>✓</div>
      <h3 style={s.successTitle}>Message envoyé !</h3>
      <p style={s.successSub}>
        Nous avons bien reçu votre message et vous répondrons dans les 24 heures ouvrées.
        Vérifiez vos spams si vous ne recevez pas de réponse.
      </p>
      <button style={s.btnDark} onClick={() => setStatus(null)}>Envoyer un autre message</button>
    </div>
  );

  return (
    <div style={s.formCard}>
      <h2 style={s.formTitle}>Envoyez-nous un message</h2>
      <p style={s.formSub}>Nous répondons à tous les messages sous 24h.</p>

      <div className="form-row" style={s.formRow}>
        <div style={s.formField}>
          <label style={s.fieldLabel}>Nom complet *</label>
          <input
            style={s.fieldInput}
            placeholder="Votre nom"
            value={form.name}
            onChange={e => handleChange("name", e.target.value)}
          />
        </div>
        <div style={s.formField}>
          <label style={s.fieldLabel}>Email *</label>
          <input
            type="email"
            style={s.fieldInput}
            placeholder="vous@exemple.mg"
            value={form.email}
            onChange={e => handleChange("email", e.target.value)}
          />
        </div>
      </div>

      <div className="form-row" style={s.formRow}>
        <div style={s.formField}>
          <label style={s.fieldLabel}>Téléphone</label>
          <input
            style={s.fieldInput}
            placeholder="+261 34 XXX XXX"
            value={form.phone}
            onChange={e => handleChange("phone", e.target.value)}
          />
        </div>
        <div style={s.formField}>
          <label style={s.fieldLabel}>Sujet *</label>
          <select
            style={s.fieldInput}
            value={form.topic}
            onChange={e => handleChange("topic", e.target.value)}
          >
            {TOPICS.map(t => <option key={t}>{t}</option>)}
          </select>
        </div>
      </div>

      <div style={s.formField}>
        <label style={s.fieldLabel}>Message *</label>
        <textarea
          style={{ ...s.fieldInput, height: 140, resize: "vertical", lineHeight: 1.6 }}
          placeholder="Décrivez votre problème ou votre demande en détail…"
          value={form.message}
          onChange={e => handleChange("message", e.target.value)}
        />
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 8, flexWrap: "wrap", gap: 12 }}>
        <p style={{ fontSize: 11, color: "#bbb", margin: 0 }}>* Champs obligatoires</p>
        <button
          style={{
            ...s.submitBtn,
            opacity: status === "loading" ? 0.7 : 1,
            cursor: status === "loading" ? "wait" : "pointer",
          }}
          onClick={handleSubmit}
          disabled={status === "loading"}
        >
          {status === "loading" ? "Envoi en cours…" : "Envoyer le message →"}
        </button>
      </div>
    </div>
  );
};

/* ── page ── */
const Contact = () => (
  <div style={s.page}>
    <style>{css}</style>
    <Header />

    {/* HERO */}
    <div style={s.hero}>
      <div style={s.heroBadge}><span style={s.badgeDot} />Nous sommes là pour vous aider</div>
      <h1 style={s.heroTitle}>
        Contactez <em style={{ color: "#16a34a", fontStyle: "normal" }}>TransTigo</em>
      </h1>
      <p style={s.heroSub}>
        Une question, un problème ou une suggestion ? Notre équipe vous répondra rapidement.
      </p>
    </div>

    {/* CHANNELS */}
    <div className="channels-wrap" style={s.channelsWrap}>
      {CHANNELS.map(c => (
        <div key={c.label} style={{ ...s.channelCard, background: c.color }} className="channel-card">
          <div style={{ fontSize: 22, marginBottom: 10 }}>{c.icon}</div>
          <div style={s.channelLabel}>{c.label}</div>
          <div style={{ ...s.channelValue, color: c.accent }}>{c.value}</div>
          {c.value2 && (
            <div style={{ ...s.channelValue, color: c.accent }}>{c.value2}</div>
          )}
          <div style={s.channelDesc}>{c.desc}</div>
        </div>
      ))}
    </div>

    {/* MAIN SPLIT */}
    <div className="main-split" style={s.mainSplit}>
      <div style={{ flex: "1 1 0", minWidth: 0 }}>
        <ContactForm />
      </div>

      <div style={s.sideInfo} className="side-info">
        {/* Transporter CTA */}
        <div style={s.sideCard}>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, color: "#16a34a", marginBottom: 8 }}>
            Devenez transporteur
          </div>
          <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 8, letterSpacing: -0.3 }}>
            Vous avez un véhicule ?
          </h3>
          <p style={{ fontSize: 13, color: "#666", lineHeight: 1.7, marginBottom: 16 }}>
            Rejoignez notre réseau de transporteurs vérifiés et développez votre activité grâce à notre plateforme.
          </p>
          <Link to="/register?type=transporter" style={{ ...s.btnDark, display: "block", textAlign: "center", textDecoration: "none" }}>
            Rejoindre le réseau
          </Link>
        </div>

        {/* Hours */}
        <div style={s.sideCard}>
          <h3 style={{ fontSize: 14, fontWeight: 700, marginBottom: 14, letterSpacing: -0.2 }}>Horaires du support</h3>
          {[
            ["Lundi – Vendredi",  "07h00 – 19h00"],
            ["Samedi",            "08h00 – 17h00"],
            ["Dimanche",          "09h00 – 13h00"],
            ["Jours fériés",      "Fermé"],
          ].map(([day, hours]) => (
            <div key={day} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "0.5px solid #f0f0f0" }}>
              <span style={{ fontSize: 13, color: "#666" }}>{day}</span>
              <span style={{ fontSize: 13, fontWeight: 600, color: hours === "Fermé" ? "#f87171" : "#1a1a1a" }}>{hours}</span>
            </div>
          ))}
        </div>

        {/* Social */}
        <div style={s.sideCard}>
          <h3 style={{ fontSize: 14, fontWeight: 700, marginBottom: 14 }}>Réseaux sociaux</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {[
              {
                icon: "f",
                label: "Facebook",
                handle: "@TransTigoMG",
                color: "#1877f2",
                href: "https://www.facebook.com/share/1GtdC8uvQT/?mibextid=wwXIfr",
              },
              {
                icon: "in",
                label: "Instagram",
                handle: "@transtigo.mg",
                color: "#e1306c",
                href: "https://www.instagram.com/transtigo.mg?igsh=eTU2dDZ5NjR2bjEy",
              },
            ].map(soc => (
              <a
                key={soc.label}
                href={soc.href}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none" }}
              >
                <div style={{ width: 32, height: 32, borderRadius: 8, background: `${soc.color}15`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 800, color: soc.color }}>
                  {soc.icon}
                </div>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: "#1a1a1a" }}>{soc.label}</div>
                  <div style={{ fontSize: 11, color: "#999" }}>{soc.handle}</div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>

    <footer style={s.footer} className="footer">
      <div style={{ fontSize: 13, color: "#999" }}>© 2025 TransTigo · Madagascar</div>
      <div style={{ display: "flex", gap: 20 }}>
        {["Confidentialité", "Conditions"].map(l => (
          <Link key={l} to={`/${l.toLowerCase()}`} style={{ fontSize: 12, color: "#bbb", textDecoration: "none" }}>{l}</Link>
        ))}
      </div>
    </footer>
  </div>
);

/* ── styles ── */
const s = {
  page:           { fontFamily: "'Plus Jakarta Sans',sans-serif", background: "#fafaf8", color: "#1a1a1a", minHeight: "100vh" },
  header:         { position: "sticky", top: 0, zIndex: 100, background: "rgba(250,250,248,0.92)", backdropFilter: "blur(12px)", borderBottom: "0.5px solid rgba(0,0,0,0.07)", padding: "0 48px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 60, flexWrap: "wrap" },
  logo:           { fontSize: 18, fontWeight: 700, letterSpacing: -0.5, color: "#1a1a1a", textDecoration: "none" },
  nav:            { display: "flex", alignItems: "center", gap: 28 },
  navLink:        { fontSize: 13.5, color: "#666", textDecoration: "none" },
  btnGhost:       { fontSize: 13, padding: "7px 16px", background: "none", border: "0.5px solid #d0d0d0", borderRadius: 8, cursor: "pointer", fontFamily: "inherit", color: "#444", textDecoration: "none" },
  btnPrimary:     { fontSize: 13, padding: "7px 16px", background: "#1a1a1a", color: "white", border: "none", borderRadius: 8, fontFamily: "inherit", fontWeight: 500, textDecoration: "none" },
  btnDark:        { padding: "10px 20px", background: "#1a1a1a", color: "white", border: "none", borderRadius: 9, fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" },

  hamburger:      { display: "none", flexDirection: "column", gap: 5, background: "none", border: "none", cursor: "pointer", padding: 4 },
  hamburgerBar:   { display: "block", width: 22, height: 2, background: "#1a1a1a", borderRadius: 2, transition: "all 0.2s" },
  mobileMenu:     { width: "100%", background: "rgba(250,250,248,0.98)", borderTop: "0.5px solid #e8e8e4", display: "flex", flexDirection: "column", padding: "12px 0 8px" },
  mobileNavLink:  { fontSize: 15, fontWeight: 500, color: "#1a1a1a", textDecoration: "none", padding: "12px 0", borderBottom: "0.5px solid #f0f0f0" },

  hero:           { padding: "64px 48px 40px", textAlign: "center" },
  heroBadge:      { display: "inline-flex", alignItems: "center", gap: 6, background: "#f0fdf4", border: "0.5px solid #bbf7d0", padding: "5px 14px", borderRadius: 20, fontSize: 12, color: "#16a34a", fontWeight: 500, marginBottom: 20 },
  badgeDot:       { width: 6, height: 6, background: "#16a34a", borderRadius: "50%", display: "inline-block", marginRight: 2 },
  heroTitle:      { fontSize: 44, fontWeight: 700, letterSpacing: -1.5, marginBottom: 14, lineHeight: 1.1 },
  heroSub:        { fontSize: 15, color: "#666", lineHeight: 1.7, maxWidth: 500, margin: "0 auto" },

  channelsWrap:   { maxWidth: 1100, margin: "0 auto", padding: "32px 48px", display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 14 },
  channelCard:    { borderRadius: 12, padding: "20px 18px", border: "0.5px solid rgba(0,0,0,0.04)" },
  channelLabel:   { fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.8, color: "#999", marginBottom: 4 },
  channelValue:   { fontSize: 13, fontWeight: 700, marginBottom: 4 },
  channelDesc:    { fontSize: 11, color: "#999" },

  mainSplit:      { maxWidth: 1100, margin: "0 auto", padding: "0 48px 64px", display: "flex", gap: 24, alignItems: "flex-start" },
  formCard:       { background: "white", border: "0.5px solid #e8e8e4", borderRadius: 16, padding: 28 },
  formTitle:      { fontSize: 18, fontWeight: 700, letterSpacing: -0.4, marginBottom: 6 },
  formSub:        { fontSize: 13, color: "#666", marginBottom: 24 },
  formRow:        { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 },
  formField:      { display: "flex", flexDirection: "column", gap: 5, marginBottom: 12 },
  fieldLabel:     { fontSize: 11, color: "#999", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 },
  fieldInput:     { padding: "12px 14px", border: "0.5px solid #e0e0e0", borderRadius: 9, fontSize: 14, fontFamily: "inherit", color: "#1a1a1a", background: "#fafaf8", outline: "none", width: "100%", boxSizing: "border-box" },
  submitBtn:      { padding: "12px 28px", background: "#1a1a1a", color: "white", border: "none", borderRadius: 10, fontSize: 13.5, fontWeight: 600, fontFamily: "inherit", width: "100%" },
  successBox:     { background: "white", border: "0.5px solid #e8e8e4", borderRadius: 16, padding: "48px 28px", textAlign: "center" },
  successIcon:    { width: 56, height: 56, borderRadius: "50%", background: "#f0fdf4", border: "0.5px solid #bbf7d0", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, color: "#16a34a", margin: "0 auto 16px" },
  successTitle:   { fontSize: 20, fontWeight: 700, color: "#1a1a1a", marginBottom: 10 },
  successSub:     { fontSize: 13, color: "#666", lineHeight: 1.7, marginBottom: 24 },

  sideInfo:       { width: 280, flexShrink: 0, display: "flex", flexDirection: "column", gap: 14 },
  sideCard:       { background: "white", border: "0.5px solid #e8e8e4", borderRadius: 14, padding: "20px 18px" },

  footer:         { padding: "24px 48px", borderTop: "0.5px solid #e8e8e4", display: "flex", alignItems: "center", justifyContent: "space-between", background: "white" },
};

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

  .channel-card:hover { transform: translateY(-2px); transition: all 0.2s; }

  /* ── Tablet (≤ 900px) ── */
  @media (max-width: 900px) {
    .desktop-nav { display: none !important; }
    .hamburger   { display: flex !important; }

    header { padding: 0 20px !important; height: auto !important; min-height: 60px; }

    .hero { padding: 48px 24px 32px !important; }
    .hero h1 { font-size: 32px !important; }

    .channels-wrap {
      grid-template-columns: repeat(2, 1fr) !important;
      padding: 24px 20px !important;
    }

    .main-split {
      flex-direction: column !important;
      padding: 0 20px 48px !important;
    }

    .side-info {
      width: 100% !important;
    }

    .footer {
      flex-direction: column !important;
      gap: 12px !important;
      padding: 20px 24px !important;
      text-align: center;
    }
  }

  /* ── Mobile (≤ 540px) ── */
  @media (max-width: 540px) {
    .channels-wrap {
      grid-template-columns: 1fr !important;
      gap: 10px !important;
    }

    .form-row {
      grid-template-columns: 1fr !important;
    }

    .hero h1 { font-size: 28px !important; letter-spacing: -1px !important; }
    .hero p  { font-size: 14px !important; }
  }
`;

export default Contact;